import { uniqBy } from 'lodash';



const uniqTags = (task) => {
  return (task.project && task.project.tags) ? uniqBy(task.project.tags, (item) => item.id) : [];
};

export default uniqTags;
